export default __webpack_public_path__ + "static/media/7minfitness_2@3x.56bcd357.jpg";